import React, { Fragment } from "react";
import CooperativesDetailReceiptsTable from "containers/cooperativesDetailReceiptsTable";
export default function() {
  return (
    <Fragment>
      <CooperativesDetailReceiptsTable />
    </Fragment>
  );
}